// extracted by mini-css-extract-plugin
module.exports = {"Ticker":"Ticker_Ticker__2t14F","message":"Ticker_message__W-nnG"};